import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react'; 

const ContactForm = () => {
  return (
    <section id="contact" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-[#0A1929] mb-4">Contact Us</h2>
          <p className="text-xl text-gray-600">Have questions? We're here to help</p>
        </motion.div>

        <div className="flex flex-col items-center lg:flex-row lg:justify-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center lg:text-left max-w-xl"
          >
            <h3 className="text-2xl font-bold text-[#0A1929] mb-6">Get in Touch Directly</h3>
            <p className="text-gray-600 mb-8">
              For any questions regarding our services, orders, or general inquiries, please reach out to us directly via email. We aim to respond promptly to all messages.
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-4">
              <div className="bg-[#FF6B35] p-3 rounded-lg flex-shrink-0">
                <Mail className="text-white" size={24} />
              </div>
              <div>
                <p className="font-semibold text-[#0A1929]">Email us at:</p>
                <a 
                  href="mailto:support@directautoreports.com" 
                  className="text-blue-600 hover:text-blue-800 underline transition-colors duration-200"
                >
                  support@directautoreports.com
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;